import React from 'react';
import { Globe, Smartphone, TrendingUp } from 'lucide-react';
export function WorldChangedSection() {
  return <section className="py-12 bg-white" data-id="element-245">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="max-w-4xl mx-auto" data-id="element-247">
          <div className="text-center mb-12" data-id="element-248">
            <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-4" data-id="element-249">
              El mundo ya cambió{' '}
              <span className="text-rose-500" data-id="element-250">(y tú puedes subirte)</span>
            </h2>
            <p className="text-lg text-warm-600" data-id="element-251">
              Mientras tú dudas, otras ya están cobrando por cosas que tú
              también podrías hacer.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-252">
            <div className="text-center p-6 rounded-xl bg-rose-50" data-id="element-253">
              <Globe className="w-10 h-10 text-rose-500 mx-auto mb-4" data-id="element-254" />
              <p className="font-medium text-warm-800" data-id="element-255">
                La economía gig crece con fuerza en México
              </p>
            </div>
            <div className="text-center p-6 rounded-xl bg-rose-50" data-id="element-256">
              <Smartphone className="w-10 h-10 text-rose-500 mx-auto mb-4" data-id="element-257" />
              <p className="font-medium text-warm-800" data-id="element-258">
                Miles de mujeres usan su cel para generar ingresos
              </p>
            </div>
            <div className="text-center p-6 rounded-xl bg-rose-50" data-id="element-259">
              <TrendingUp className="w-10 h-10 text-rose-500 mx-auto mb-4" data-id="element-260" />
              <p className="font-medium text-warm-800" data-id="element-261">
                Los side hustles compensan sueldos bajos
              </p>
            </div>
          </div>

          <div className="bg-warm-900 text-warm-50 p-8 md:p-10 rounded-2xl text-center shadow-xl" data-id="element-262">
            <h3 className="text-2xl font-serif mb-4" data-id="element-263">
              Traducción a lenguaje real:
            </h3>
            <p className="text-lg leading-relaxed opacity-90 mb-6" data-id="element-264">
              La diferencia entre ellas y tú no es que sean más listas, más
              guapas o más afortunadas. La diferencia es que ellas encontraron
              un mapa claro.
            </p>
            <p className="font-bold text-rose-300 text-xl" data-id="element-265">
              Eso es exactamente lo que vengo a cambiar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}